export const NAVIGATION_TABS_ALL_POSTS = 'navigation-tabs.all-posts';
export const NAVIGATION_TABS_EXTERNAL_LINKS = 'navigation-tabs.external-links';
export const NAVIGATION_TABS_INVISIBLE_POSTS = 'navigation-tabs.invisible-posts';
export const NAVIGATION_TABS_ABOUT_SITE = 'navigation-tabs.about-site';
